import { render, staticRenderFns } from "./ProjectForm.vue?vue&type=template&id=2b56f1f6&scoped=true&"
import script from "./ProjectForm.vue?vue&type=script&lang=js&"
export * from "./ProjectForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56f1f6",
  null
  
)

export default component.exports